import { setDefaultStyle } from "apparatus/draw";
import { P, Segments } from "apparatus/library/common";
import { Group, Path, PointText } from "paper";
export class Ramp {
    constructor() {
        this.shouldUseBoundsCenter = true;
    }
    render(appearance) {
        const { length: lengthM, angle } = appearance;
        const length = lengthM * 1000;
        const height = length * Math.sin(angle.toRadians());
        const width = length * Math.cos(angle.toRadians());
        const ramp = new Path(Segments([[0, 0]], [[width, height]], [[0, height]])).close()
            .withStroke("default")
            .withFill("#aaaaaa");
        setDefaultStyle(ramp);
        const pivot = P(width, height);
        let graphic;
        if (appearance.showLabel) {
            graphic = new Group([ramp]);
            // Calculate where to place the label
            const labelRadius = Math.max(70, 30 / Math.tan(angle.toRadians()));
            const start = P(width - labelRadius, height);
            const mid = start.rotate(angle / 2, pivot);
            const end = start.rotate(angle, pivot);
            graphic.addChild(new Path.Arc(start, mid, end).withStroke("default", "black"));
            const label = new PointText({
                point: start.add(P(-20, 0)).rotate(angle / 2, pivot).add(P(0, 5)),
                content: `${angle}°`,
                fontFamily: 'sans-serif',
                fontSize: 15,
                fillColor: "black",
                justification: "center"
            });
            if (appearance.flipped) {
                label.scale(-1, 1);
            }
            graphic.addChild(label);
        }
        else {
            graphic = ramp;
        }
        if (appearance.flipped) {
            graphic.scale(-1, 1, pivot);
        }
        const hitShape = ramp.clone();
        return {
            graphic,
            hitShape,
            pivot,
            snapping: [
                { type: "placeable_surface", start: P(0, 0), end: P(width, height), facing: "auto" },
                { type: "placeable", at: ramp.strokeBounds.bottomCenter }
            ]
        };
    }
}
Ramp.properties = {
    label: "Ramp",
    defaultAppearance: {
        length: 1.0,
        angle: 25,
        showLabel: true,
        flipped: false,
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "length", label: "Length",
            min: 0.5, max: 2.5, step: 0.05, unit: "m"
        },
        {
            spec: "slider", key: "angle", label: "Angle",
            min: 5, max: 45, step: 1, unit: "°",
        },
        {
            spec: "checkbox-group", label: "Options", checkboxes: [
                { key: "showLabel", label: "Label incline" },
                { key: "flipped", label: "Flip horizontally" },
            ]
        }
    ],
};
